/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index heading to autogenerate all the components and extensions
 * Used by "prepareHeadings"
 */

import Heading from './heading/Heading'
export * from './heading/Heading'
export default Heading
